type EventType = string | number;

export interface EventHandler<C, P> {
  (this: C, event: P): void;
}

export default class EventEmitter<C, E extends EventType, P> {
  protected emitterContext?: C;

  private listeners: { [event: string]: EventHandler<C, P>[] };

  constructor(context?: C) {
    this.emitterContext = context;
    this.listeners = {};
  }

  on(type: E, listener: EventHandler<C, P>) {
    if (Object.prototype.hasOwnProperty.call(this.listeners, type)) {
      this.listeners[type].push(listener);
    } else {
      this.listeners[type] = [listener];
    }
  }

  off(type: E, listener: EventHandler<C, P>) {
    if (Object.prototype.hasOwnProperty.call(this.listeners, type)) {
      const listenerIndex = this.listeners[type].indexOf(listener);
      if (listenerIndex !== -1) {
        this.listeners[type].splice(listenerIndex, 1);
      }
    }
  }

  protected emit(type: E, payload: P) {
    if (!this.emitterContext) throw new Error('Context is not set on EventEmitter');
    if (this.listeners[type]) {
      this.listeners[type].forEach((listener) => {
        if (this.emitterContext) {
          listener.call(this.emitterContext, payload);
        }
      });
    }
  }
}
